import React from 'react';
import { classNames } from 'tradera/utils/class-names';
import { getAdSize } from './holid-ad-helper';
import type { AdFormat } from './ad-format';
import HolidAd from './holid-ad';
import styles from './holid-ad.module.scss';

export type HolidAdWrapperProps = {
    adFormat: AdFormat;
    text: string;
    className?: string;
};

const HolidAdWrapper = ({
    adFormat,
    text = 'Annons',
    className
}: HolidAdWrapperProps) => {
    const adSize = getAdSize(adFormat);
    return (
        <div
            className={classNames(
                styles.holidAd,
                styles.holidAdLoaded,
                className
            )}
            // This functions as a fixed size placeholder to prevent CLS
            style={{
                width: adSize[0],
                height: adSize[1]
            }}
            data-label-text={text}>
            <HolidAd adFormat={adFormat} adSize={adSize} />
        </div>
    );
};

export default React.memo(HolidAdWrapper);
